"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _camelToTitleCase = _interopRequireDefault(require("../camelToTitleCase"));
var _excluded = ["className", "field", "object", "options", "onChange", "label", "selected"];
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/InputSelect/index.js";
var defaultProps = {
  field: '',
  selected: -1
};
function InputSelect(_ref) {
  var _this = this;
  var className = _ref.className,
    field = _ref.field,
    object = _ref.object,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    onChange = _ref.onChange,
    label = _ref.label,
    selected = _ref.selected,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  function change(e) {
    var value = e.target.value;
    object[field] = value;
    onChange && onChange(value);
  }
  var value = object[field];
  return /*#__PURE__*/_react["default"].createElement("select", Object.assign({
    className: (0, _classNames["default"])('form-select', className),
    onChange: change,
    defaultValue: value || ""
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 9
    }
  }), /*#__PURE__*/_react["default"].createElement("option", {
    value: "",
    disabled: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 13
    }
  }, label || "Select ".concat((0, _camelToTitleCase["default"])(field))), options.map(function (o, i) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: i,
      value: o.value || o,
      selected: value === (o.value || o) || selected === i,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 30,
        columnNumber: 25
      }
    }, o.label || o);
  }));
}
InputSelect.defaultProps = defaultProps;
var _default = InputSelect;
exports["default"] = _default;